import getDeviceInfo from '../../shim/deviceInfo'
import objectPath from 'object-path'
import {FetchErrorPromiseResolver} from '../../error/fetch-error'
import Config from '../../config'
import url from 'url'
import {createClient as createFetchClientOrginal} from "fetch-plus"
import jsonMiddlewareFetchPlus from 'fetch-plus-json'

let store

export function setStore(st){
	store = st
}

export function logMiddleware(request){
	if(__DEV__){
		const headers = request.options.headers || {}

		console.log(`${request.options.method || 'GET'} ${request.url}${request.path || ''} ${request.query ? '?' + Object.entries(request.options.query).map(([key, value]) => `${key}=${value}`).join('&') : ''}
${Object.entries(headers).map(([key, value]) => `${key}: ${value}`).join('\n')}
${request.options.body instanceof Object ? JSON.stringify(request.options.body) : request.options.body || ''}
	`)

		return {
			after: (response) => {
				console.log(`Response for ${request.url}${request.path || ''} \n${Object.entries(headers).map(([key, value]) => `${key}: ${value}`).join('\n')}`)
				if(response.headers.has('Content-Type')){
					if(response.headers.get('Content-Type').indexOf('json') !== -1){
						response.clone().json().then((data) => {
							console.log('JSON: ', data)
						})
					}
				}
				return response
			},

			error: (response) => {
				if(response && response.clone){
					if(response.headers.get('Content-Type').indexOf('json') !== -1){
						response.clone().json()
							.then((data) => {
								console.log("FETCH Response Error", data)
							})
					}
				}

				return false
			}
		}
	}
}

export function errorMiddleware(){
	return {
		error: (response) => {
			if(response.ok){
				return false // == don't capture exception, let it bubble
			}else{
				return FetchErrorPromiseResolver(response) // wrap the server exception into a fetchError
			}
		}
	}
}

/**
 * Middleware for fetch-plus
 * @param request
 */
export function authMiddleware(request){
	if(store && store.getState){
		const token = objectPath.get(store.getState(), ['Auth', 'token', 'accessToken'])
		if(token) request.options.headers["Authorization"] = `Bearer ${token}`
	}
}

export function authMiddlewareXMLHttp(xhr){
	if(store && store.getState){
		const token = objectPath.get(store.getState(), ['Auth', 'token', 'accessToken'])
		if(token) xhr.setRequestHeader('Authorization', `Bearer ${token}`)
	}
}

export function headerMiddleware(request){
	request.options.headers["User-Agent"] = `${getDeviceInfo().getUserAgent()} MyBudgetApp/${Config.BUILD_NUMBER}`
}

/**
 * Fetch plus middleware doesn't check the Content-Type
 * @param options
 * @return {function(*=)}
 */
function jsonMiddleware(options){
	const middleware = jsonMiddlewareFetchPlus(options)

	return (request) => {
		const after = middleware(request)

		return {
			after: (response) => {
				if(response.headers && response.headers.get('Content-Type').indexOf('json') !== -1){
					return after(response)
				}

				return response
			}
		}
	}
}

/**
 * Creates a fetch plus client with default middleware
 * @param endpoint
 * @param headers
 * @param preMiddleware
 * @param postMiddleware
 */
export function createFetchClient(endpoint, headers={}, preMiddleware=[], postMiddleware=[]){
	if(!endpoint.startsWith('http')){
		endpoint = url.resolve(Config.MYBUDGETAPI_ENDPOINT, endpoint)
	}

	return createFetchClientOrginal(endpoint, {headers: headers}, [...preMiddleware, headerMiddleware, logMiddleware, jsonMiddleware(), errorMiddleware, ...postMiddleware])
}

/**
 * Creates a fetch plus client with default middleware + auth
 * @param endpoint
 * @param headers
 * @param preMiddleware
 * @param postMiddleware
 */
export function createFetchClientWithAuth(endpoint, headers, preMiddleware=[], postMiddleware=[]){
	return createFetchClient(endpoint, headers, [authMiddleware, ...preMiddleware], postMiddleware)
}




// WEBPACK FOOTER //
// ./node_modules/mb-app-common/lib/util/request/middleware.js